var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 0C8.50575 0 0 8.49103 0 18.9671C0 27.3438 5.44493 34.4526 12.9929 36.9677C13.9403 37.1444 14.2942 36.552 14.2942 36.0531C14.2942 35.5958 14.2734 34.1096 14.2734 32.5195C8.98466 33.6627 7.87069 30.285 7.87069 30.285C7.00658 28.0921 5.75726 27.5101 5.75726 27.5101C4.02904 26.3357 5.88219 26.3565 5.88219 26.3565C7.7874 26.4916 8.79726 28.3104 8.79726 28.3104C10.4942 31.21 13.2427 30.3682 14.3255 29.8901C14.4921 28.6637 14.9918 27.8323 15.5332 27.3542C11.3167 26.8761 6.87123 25.2444 6.87123 17.9798C6.87123 15.9116 7.61041 14.2175 8.82849 12.8872C8.63069 12.4092 7.98521 10.4761 9.01589 7.86745C9.01589 7.86745 10.6088 7.3582 14.2422 9.81093C15.7622 9.39522 17.3863 9.17697 19 9.17697C20.6137 9.18736 22.2378 9.39522 23.7578 9.81093C27.3808 7.3582 28.9737 7.86745 28.9737 7.86745C30.0044 10.4761 29.3589 12.4092 29.1611 12.8872C30.3792 14.2175 31.1184 15.9116 31.1184 17.9798C31.1184 25.2652 26.6729 26.8657 22.446 27.3334C23.1227 27.9258 23.737 29.0794 23.737 30.8462C23.737 33.3821 23.7162 35.4295 23.7162 36.0531C23.7162 36.5624 24.0597 37.1444 25.0175 36.9677C32.5655 34.4526 38 27.3542 38 18.9671C38 8.49103 29.4942 0 19 0Z",
    fill: "#002E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.c81fb63b889067c3dd9ad1b86dcb5f7d.svg";
export { ForwardRef as ReactComponent };